const MAX_IMAGE = 1000; // TODO: move to constants

function resizeActivityImage(img: HTMLImageElement, type) {
  let canvas = document.createElement('canvas');
  let width = img.width;
  let height = img.height;
  const ratio = width / height;

  const MAX_IMAGE_ACTIVITY = 400;

  if (ratio >= 1 && img.width > MAX_IMAGE_ACTIVITY) {
    width = MAX_IMAGE_ACTIVITY;
    height = Math.round(width / ratio);
  }

  if (ratio < 1 && img.height > MAX_IMAGE_ACTIVITY) {
    height = MAX_IMAGE_ACTIVITY;
    width = Math.round(height * ratio);
  }

  canvas.width = width;
  canvas.height = height;
  canvas.getContext('2d').drawImage(img, 0, 0, width, height);
  const data = canvas.toDataURL(type);

  canvas = null;

  return {data: data, w: width, h: height};
}

function resizeImage(img: HTMLImageElement, type) {
  let canvas = document.createElement('canvas');
  let width = img.width;
  let height = img.height;
  const ratio = width / height;

  if (ratio >= 1 && img.width > MAX_IMAGE) {
    width = MAX_IMAGE;
    height = Math.round(width / ratio);
  }

  if (ratio < 1 && img.height > MAX_IMAGE) {
    height = MAX_IMAGE;
    width = Math.round(height * ratio);
  }

  canvas.width = width;
  canvas.height = height;
  canvas.getContext('2d').drawImage(img, 0, 0, width, height);
  const data = canvas.toDataURL(type);

  canvas = null;

  return {
    data: data,
    w: width,
    h: height
  };
}

function urlToBlob(dataURL) {
  const BASE64_MARKER = ';base64,';
  let parts, contentType, raw;

  if (dataURL.indexOf(BASE64_MARKER) === -1) {
    parts = dataURL.split(',');
    contentType = parts[0].split(':')[1];
    raw = parts[1];

    return new Blob([raw], {type: contentType});
  }

  parts = dataURL.split(BASE64_MARKER);
  contentType = parts[0].split(':')[1];
  raw = window.atob(parts[1]);
  const rawLength = raw.length;

  const uInt8Array = new Uint8Array(rawLength);

  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], {type: contentType});
}

export {urlToBlob, resizeImage, resizeActivityImage};
